import React, { useState, useEffect, useMemo, useRef } from 'react';
import { db } from '../../firebase.js';
import { collection, orderBy, limit, query, getDocs, getDoc, getCountFromServer, updateDoc, collectionGroup, where, doc } from "firebase/firestore"
import { getDownloadURL, ref } from 'firebase/storage';
import { useNavigate, useParams } from 'react-router-dom';

import JSZip from "jszip";
import { saveAs } from "file-saver";

import { useUnitDataCache } from '../DashBoardPage/sub-pages/ImagesSubPage/../../../../contexts/UnitDataCacheContext';
import { useSecondHeader } from './../DashBoardPage/sub-pages/ImagesSubPage/../../../../contexts/SecondHeaderContext';
//import { Dialog } from '@material-ui/core'; // Assuming you're using Material-UI
import DatePickerComponent from '../DashBoardPage/sub-pages/ImagesSubPage/../../../../components/DatePicker/DatePicker';
import './../DashBoardPage/sub-pages/ImagesSubPage/ImagesSubPage.jsx'; // Import the styles
import RecordDialog from './../DashBoardPage/sub-pages/ImagesSubPage/RecordDialog/RecordDialog.jsx';
import { Modal } from '@mui/material';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { DialogRecordProvider } from './../DashBoardPage/sub-pages/ImagesSubPage/RecordDialog/RecordDialogContext';
import { useTranslation } from 'react-i18next';

import down_arrow from "./../DashBoardPage/sub-pages/ImagesSubPage/../../../../assets/icons/down-arrow.svg"
import { useUnitDataParser } from '../DashBoardPage/sub-pages/ImagesSubPage/../../../../contexts/UnitDataParserContext.js';
import { use } from 'i18next';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useUser } from '../DashBoardPage/sub-pages/ImagesSubPage/../../../../contexts/UserContext';
import { auth, storage } from '../DashBoardPage/sub-pages/ImagesSubPage/../../../../firebase';
import meat_balls from "./../DashBoardPage/sub-pages/ImagesSubPage/../../../../assets/icons/three_dots.svg"
import { getDateLocaleFromLanguage } from "../DashBoardPage/sub-pages/ImagesSubPage/../../../../common/dateTools.js";
import DangerousWasteRecordDialog from "./DangerousWasteRecordDialog/DangerousWasteRecordDialog.jsx"
import { getCurrentWritableUnitId } from "../../common/displayUnitRanges.js";
import {
    getDangerousWasteColumnsOrFallback,
    getDangerousWasteRecordTableValue,
    getDangerousWasteRecordValue,
    LEGACY_DANGEROUS_WASTE_COLUMNS,
} from "../../common/dangerousWasteRecordColumns.js";
import {
    getVisibleWasteReceiverColumns,
    normalizeWasteReceiverColumns,
    normalizeWasteReceiverDoc,
    normalizeWasteReceiverGroupingColumns,
    WASTE_RECEIVERS_COLLECTION,
} from "../../common/wasteReceivers.js";
import {
    buildAnonymizedActorLabelById,
    buildCompanyMembershipViewAllByCompany,
    getAppRecordActorBadgeModel,
    getRecordActorId,
} from '../../common/appRecordActorDisplay.js';
import { buildDangerousWasteRecordGroups } from '../../common/dangerousWasteRecordGroups.js';
import {
    buildAppRecordScopes,
    buildMachineRecordScopes,
    fetchDangerousWasteRecords,
} from './dangerousWasteRecordQueries.js';
import {
    buildActivationTrend,
    DEFAULT_TREND_WINDOW_DAYS,
    getTrendFetchRange,
} from '../../common/activationTrend.js';
import DangerousWasteDashboardPane from './DangerousWasteDashboardPane.jsx';
import './DangerousWasteImagesPage.css';

const APP_OWNER_TYPES = {
    company: 'company',
    wasteReceiver: 'waste-receiver',
};

const COMPANY_APP_RECORDS_COLLECTION = 'company_app_records';
const WASTE_RECEIVER_APP_RECORDS_COLLECTIONS = [
    'waste_receiver_app_records',
    'waster_receiver_app_records',
];

const getAppRecordCollectionPaths = (ownerType, ownerId) => {
    if (ownerType === APP_OWNER_TYPES.company) {
        return [`${COMPANY_APP_RECORDS_COLLECTION}/${ownerId}/dangerous-waste-records`];
    }

    if (ownerType === APP_OWNER_TYPES.wasteReceiver) {
        return WASTE_RECEIVER_APP_RECORDS_COLLECTIONS.map(
            (collectionName) => `${collectionName}/${ownerId}/dangerous-waste-records`
        );
    }

    return [];
};

const normalizeEvalRequestsMap = (rawValue) => {
    if (!rawValue) return {};

    if (Array.isArray(rawValue)) {
        const converted = {};
        rawValue.forEach((request, index) => {
            const requestId = String(request?.id || `request_${index}`);
            converted[requestId] = request;
        });
        return converted;
    }

    if (typeof rawValue === 'object') {
        return rawValue;
    }

    return {};
};

const hasUnresolvedEvalRequests = (record) => {
    const evalRequests = normalizeEvalRequestsMap(record?.user_eval_requests);
    return Object.values(evalRequests).some((request) => !Boolean(request?.resolved));
};

export const DANGEROUS_WASTE_PANES = {
    dashboard: 'dashboard',
    images: 'images',
    markedForReview: 'marked-for-review',
    evaluatedImages: 'evaluated-images',
};

const EVALUATED_VERDICT_FILTERS = [
    { value: 'all', label: 'Alle' },
    { value: 'correct', label: 'Korrekt' },
    { value: 'incorrect', label: 'Forkert' },
    { value: 'unresolved', label: 'Uafklaret' },
];

// The last instant of the period the date picker reports, derived from its start and
// unit so that the same selection always yields the same period.
const getPeriodEndUnix = (startUnix, timeUnit) => {
    const start = new Date(startUnix);

    switch (timeUnit) {
        case 'month':
            return new Date(start.getFullYear(), start.getMonth() + 1, 1).getTime() - 1;
        case 'week':
            return startUnix + (7 * 24 * 60 * 60 * 1000) - 1;
        default:
            return new Date(start.getFullYear() + 1, 0, 1).getTime() - 1;
    }
};

function DangerousWasteImagesPage() {
    const TABLE_CELL_PREVIEW_MAX = 25;

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { unitId, locationId, appOwnerType, appOwnerId, pane } = useParams();
    const isAppRecordsPage = Boolean(appOwnerType && appOwnerId);
    const currentPane = Object.values(DANGEROUS_WASTE_PANES).includes(pane)
        ? pane
        : DANGEROUS_WASTE_PANES.dashboard;
    const isDashboardPane = currentPane === DANGEROUS_WASTE_PANES.dashboard;
    const isMarkedForReviewPane = currentPane === DANGEROUS_WASTE_PANES.markedForReview;
    const isEvaluatedImagesPane = currentPane === DANGEROUS_WASTE_PANES.evaluatedImages;

    const paneBasePath = isAppRecordsPage
        ? `/app-records/${appOwnerType}/${appOwnerId}/dangerous-waste`
        : `/locations/${locationId}/unit/${unitId}/dangerous-waste`;
    const [records, setRecords] = useState([])
    const [localRecords, setLocalRecords] = useState([])
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [currentPage, setCurrentPage] = useState(0);
    
    const [ currentPageRecords, setCurrentPageRecords] = useState([]);
    const { getColorForCategory, localCustomEvalCategories, setLocalCustomEvalCategories } = useUnitDataParser();
    const [pageSize, setPageSize] = useState(50);
    const [activeFilter, setActiveFilter] = useState('');
    const [evaluatedVerdictFilter, setEvaluatedVerdictFilter] = useState('all');
    const [flipSort, setFlipSort] = useState(false);
    const [flipAccountedRecords, setFlipAccountedRecords] = useState([]);
    const [showPagePaginatorDropdown, setShowPagePaginatorDropdown] = useState(false);
    const [modalInitialIndex, setModalInitialIndex] = useState(0);
    const [isMeatBallExpanded, setIsMeatBallExpanded] = useState(false);
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [lastSelectedRecord, setLastSelectedRecord] = useState(null);
    const { getOtherUserInfo,  } = useUnitDataCache();
    const { currentUnit, setCurrentUnit, currentLocation, getUnitData, getLocationData } = useSecondHeader()

    // MARK: Refs
    const meatBallMenuRef = useRef(null);
    const meatBallButtonRef = useRef(null);
    
    // The selected period is owned here and reported by the date picker on mount,
    // which defaults to year-to-date.
    const [startUnix, setStartUnix] = useState(null);
    const [end_unix, setEndUnix] = useState(null);
    const [selectedTimeUnit, setSelectedTimeUnit] = useState('year');

    const [votedCategoryForRecords, setVotedCategoryForRecords] = useState([]);
    const [deploymentDangerousWasteColumns, setDeploymentDangerousWasteColumns] = useState(LEGACY_DANGEROUS_WASTE_COLUMNS);
    const [wasteReceiver, setWasteReceiver] = useState(null);
    const [appWasteReceiverId, setAppWasteReceiverId] = useState(null);
    const [machineWasteReceiverId, setMachineWasteReceiverId] = useState(null);
    const [allTimeRecordCount, setAllTimeRecordCount] = useState(null);
    const [pendingReviewCount, setPendingReviewCount] = useState(0);
    const [appActorProfilesById, setAppActorProfilesById] = useState({});

    // The activation trend covers a shorter window than the selected period and may reach
    // back before it, so it is fetched and held apart from the period-scoped records.
    const [trendRecordSource, setTrendRecordSource] = useState(null);
    const [trendWindowDays, setTrendWindowDays] = useState(DEFAULT_TREND_WINDOW_DAYS);
    const [trendRecords, setTrendRecords] = useState(null);
    const [isTrendLoading, setIsTrendLoading] = useState(false);
    

    const [user] = useAuthState(auth);
    const { userData } = useUser();

    // The waste receiver is resolved from the company the records belong to,
    // never from the signed-in user's own waste receiver links.
    const wasteReceiverId = isAppRecordsPage ? appWasteReceiverId : machineWasteReceiverId;

    const allDangerousWasteColumns = useMemo(() => (
        wasteReceiver
            ? normalizeWasteReceiverColumns(wasteReceiver.columns)
            : deploymentDangerousWasteColumns
    ), [wasteReceiver, deploymentDangerousWasteColumns]);

    const dangerousWasteColumns = useMemo(() => (
        wasteReceiver
            ? getVisibleWasteReceiverColumns(wasteReceiver.columns, wasteReceiver.noShowColumns)
            : deploymentDangerousWasteColumns
    ), [wasteReceiver, deploymentDangerousWasteColumns]);

    // A record's positional eval `values` line up with the waste receiver's full column set
    // (hidden columns included), not just the visible ones rendered in the table — so each
    // visible column needs its index within the full set to look its value up correctly.
    const tableColumnIndexById = useMemo(
        () => new Map(allDangerousWasteColumns.map((column, index) => [column.id, index])),
        [allDangerousWasteColumns],
    );

    const groupingColumns = useMemo(() => {
        if (!wasteReceiver) return [];

        const columnsById = new Map(dangerousWasteColumns.map((column) => [column.id, column]));
        return normalizeWasteReceiverGroupingColumns(
            wasteReceiver.groupingColumns,
            wasteReceiver.columns,
            wasteReceiver.noShowColumns,
        )
            .map((columnId) => columnsById.get(columnId))
            .filter(Boolean);
    }, [wasteReceiver, dangerousWasteColumns]);

    const recordGroups = useMemo(
        () => buildDangerousWasteRecordGroups(localRecords, groupingColumns, allDangerousWasteColumns),
        [localRecords, groupingColumns, allDangerousWasteColumns],
    );

    const prioritizedUserIds = useMemo(() => {
        const ids = Array.isArray(wasteReceiver?.userEvaluationPrioritization)
            ? wasteReceiver.userEvaluationPrioritization
            : [];
        const seen = new Set();
        return ids
            .map((id) => String(id || '').trim())
            .filter((id) => {
                if (!id || seen.has(id)) return false;
                seen.add(id);
                return true;
            });
    }, [wasteReceiver]);

    const companyMembershipViewAllByCompany = useMemo(
        () => buildCompanyMembershipViewAllByCompany(userData),
        [userData],
    );

    const anonymizedActorLabelById = useMemo(() => {
        if (!isAppRecordsPage) return {};

        return buildAnonymizedActorLabelById(flipAccountedRecords);
    }, [flipAccountedRecords, isAppRecordsPage]);

    useEffect(() => {
        if (!isAppRecordsPage) {
            setAppActorProfilesById({});
            return undefined;
        }

        const actorIds = [...new Set(
            flipAccountedRecords
                .map((record) => getRecordActorId(record))
                .filter(Boolean)
        )];

        if (actorIds.length === 0) {
            setAppActorProfilesById({});
            return undefined;
        }

        let cancelled = false;

        getOtherUserInfo(actorIds)
            .then((users) => {
                if (cancelled) return;
                const profilesById = {};
                (Array.isArray(users) ? users : []).forEach((entry, index) => {
                    const id = String(entry?.id || entry?.user_id || actorIds[index] || '').trim();
                    if (id) {
                        profilesById[id] = entry;
                    }
                });
                setAppActorProfilesById(profilesById);
            })
            .catch((error) => {
                console.error('Error loading app actor profiles:', error);
                if (!cancelled) {
                    setAppActorProfilesById({});
                }
            });

        return () => {
            cancelled = true;
        };
    }, [flipAccountedRecords, getOtherUserInfo, isAppRecordsPage]);

    const getAppRecordActorBadge = (record) => getAppRecordActorBadgeModel({
        record,
        userData,
        companyMembershipViewAllByCompany,
        anonymizedActorLabelById,
        actorProfilesById: appActorProfilesById,
    });

    const special_categories = [
        "Kan ikke vurderes", 
        //"Test", "Test", "Test", "Test", "Test", "Test", "Test", "Test", "Test"
    ]
    const specified_colors = {
        [special_categories[0]]: "#BFBFBF"
    }

    const totalPages = () => {
        return Math.ceil((isEvaluatedImagesPane ? paneRecords.length : localRecords.length) / pageSize)
    }

    async function loadDangerousWasteDisplayConfig(displayUnit) {
        const currentUnitId = getCurrentWritableUnitId(displayUnit);
        if (!currentUnitId) {
            setDeploymentDangerousWasteColumns(LEGACY_DANGEROUS_WASTE_COLUMNS);
            return;
        }

        try {
            const unitSnapshot = await getDoc(doc(db, 'units', currentUnitId));
            const deploymentConfig = unitSnapshot.exists()
                ? unitSnapshot.data()?.deployment_config
                : {};
            const columns = deploymentConfig?.columns || [];
            setDeploymentDangerousWasteColumns(getDangerousWasteColumnsOrFallback(columns));
        } catch (error) {
            console.error('Error loading dangerous-waste column config:', error);
            setDeploymentDangerousWasteColumns(LEGACY_DANGEROUS_WASTE_COLUMNS);
        }
    }

    // The trend window ends at the selected period's end and is fetched with six warm-up
    // days ahead of it, which feed the moving average and are never plotted.
    useEffect(() => {
        if (!isDashboardPane || !trendRecordSource || !Number.isFinite(end_unix)) {
            setTrendRecords(null);
            setIsTrendLoading(false);
            return undefined;
        }

        let cancelled = false;
        const { fetchStartUnix, fetchEndUnix } = getTrendFetchRange(end_unix, trendWindowDays);

        setIsTrendLoading(true);
        fetchDangerousWasteRecords(trendRecordSource.scopes, {
            startUnix: fetchStartUnix,
            endUnix: fetchEndUnix,
            deduplicateById: trendRecordSource.deduplicateById,
        })
            .then((records) => {
                if (cancelled) return;
                setTrendRecords(records);
            })
            .catch((error) => {
                console.error('Error loading activation trend records:', error);
                if (!cancelled) setTrendRecords([]);
            })
            .finally(() => {
                if (!cancelled) setIsTrendLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [isDashboardPane, trendRecordSource, end_unix, trendWindowDays]);

    const activationTrend = useMemo(() => (
        trendRecords ? buildActivationTrend(trendRecords, end_unix, trendWindowDays) : []
    ), [trendRecords, end_unix, trendWindowDays]);

    useEffect(() => {
        if (!wasteReceiverId) {
            setWasteReceiver(null);
            return undefined;
        }
        let cancelled = false;

        getDoc(doc(db, WASTE_RECEIVERS_COLLECTION, wasteReceiverId))
            .then((snap) => {
                if (cancelled) return;
                if (!snap.exists()) {
                    console.warn(`Dangerous waste: waste receiver "${wasteReceiverId}" has no document.`);
                    setWasteReceiver(null);
                    return;
                }
                const nextWasteReceiver = normalizeWasteReceiverDoc(snap);
                if (!nextWasteReceiver.groupingColumns.length) {
                    console.warn(`Dangerous waste: waste receiver "${wasteReceiverId}" has no grouping columns that are visible on the record list.`);
                }
                setWasteReceiver(nextWasteReceiver);
            })
            .catch((error) => {
                console.error('Error loading waste receiver for dangerous-waste images:', error);
                if (!cancelled) setWasteReceiver(null);
            });

        return () => {
            cancelled = true;
        };
    }, [wasteReceiverId]);

    async function resolveAppRecordOwner() {
        if (!isAppRecordsPage) return null;

        if (appOwnerType === APP_OWNER_TYPES.wasteReceiver) {
            const wasteReceiverSnap = await getDoc(doc(db, WASTE_RECEIVERS_COLLECTION, appOwnerId));
            const wasteReceiverData = wasteReceiverSnap.exists() ? wasteReceiverSnap.data() : {};
            return {
                ownerType: appOwnerType,
                ownerId: appOwnerId,
                wasteReceiverId: appOwnerId,
                displayName: `${wasteReceiverData?.name || appOwnerId} - App scanninger`,
            };
        }

        if (appOwnerType === APP_OWNER_TYPES.company) {
            const companySnap = await getDoc(doc(db, 'companies', appOwnerId));
            if (!companySnap.exists()) {
                throw new Error(`Company ${appOwnerId} does not exist.`);
            }

            const companyData = companySnap.data() || {};
            const companyWasteReceiverId = typeof companyData.waste_receiver === 'string'
                ? companyData.waste_receiver.trim()
                : '';

            if (!companyWasteReceiverId) {
                throw new Error(`Company ${appOwnerId} has no waste_receiver.`);
            }

            return {
                ownerType: appOwnerType,
                ownerId: appOwnerId,
                companyId: appOwnerId,
                wasteReceiverId: companyWasteReceiverId,
                displayName: `${companyData.name || companyData.display_name || companyData.label || appOwnerId} - App scanninger`,
            };
        }

        throw new Error(`Unsupported app owner type: ${appOwnerType}`);
    }

    async function loadAppRecords() {
        const appOwner = await resolveAppRecordOwner();
        const recordCollectionPaths = getAppRecordCollectionPaths(appOwner?.ownerType, appOwner?.ownerId);

        if (!appOwner || recordCollectionPaths.length === 0) {
            setCurrentUnit(undefined);
            setLocalRecordsAndDerivedValues([]);
            setAppWasteReceiverId(null);
            setPendingReviewCount(0);
            setTrendRecordSource(null);
            return;
        }

        setAppWasteReceiverId(appOwner.wasteReceiverId);
        setDeploymentDangerousWasteColumns(LEGACY_DANGEROUS_WASTE_COLUMNS);
        setCurrentUnit({
            display_name: appOwner.displayName,
            unit_id: `${appOwner.ownerType}-${appOwner.ownerId}-app`,
            app_record_owner_type: appOwner.ownerType,
            app_record_owner_id: appOwner.ownerId,
            company: appOwner.companyId || null,
            waste_receiver_id: appOwner.wasteReceiverId,
        });

        // The two collection spellings hold the same records, so ids are deduplicated across them.
        const recordScopes = buildAppRecordScopes(recordCollectionPaths, {
            companyId: appOwner.companyId,
            unitId: `${appOwner.ownerType}-${appOwner.ownerId}-app`,
        });
        setTrendRecordSource({ scopes: recordScopes, deduplicateById: true });

        let recordsNewValue = await fetchDangerousWasteRecords(
            recordScopes,
            {
                startUnix: isMarkedForReviewPane ? null : startUnix,
                endUnix: isMarkedForReviewPane ? null : end_unix,
                deduplicateById: true,
            },
        );

        if (isMarkedForReviewPane) {
            recordsNewValue = recordsNewValue.filter((record) => hasUnresolvedEvalRequests(record));
        }

        setLocalRecordsAndDerivedValues(recordsNewValue);
        if (isMarkedForReviewPane) {
            setAllTimeRecordCount(recordsNewValue.length);
            setPendingReviewCount(recordsNewValue.length);
        } else {
            loadAllTimeRecordCount(recordCollectionPaths.map((recordCollectionPath) => ({
                collectionPath: recordCollectionPath,
            })));

            // The review tab count is all-time unresolved and independent of period panes.
            Promise.all(
                recordCollectionPaths.map((recordCollectionPath) => (
                    getDocs(query(
                        collection(db, recordCollectionPath),
                        orderBy("timestamp", "desc"),
                    ))
                ))
            ).then((allSnapshots) => {
                const allRecordsById = new Map();
                allSnapshots.forEach((snapshot) => {
                    snapshot.docs.forEach((_doc) => {
                        if (allRecordsById.has(_doc.id)) return;
                        allRecordsById.set(_doc.id, _doc.data());
                    });
                });

                const unresolvedCount = [...allRecordsById.values()]
                    .filter((record) => record?.is_test !== true)
                    .filter((record) => hasUnresolvedEvalRequests(record))
                    .length;

                setPendingReviewCount(unresolvedCount);
            }).catch((error) => {
                console.error('Error loading app unresolved review count:', error);
                setPendingReviewCount(0);
            });
        }
    }

    // Counts every record across all time, so the period total can be read
    // against the depth of the history behind it.
    async function loadAllTimeRecordCount(recordScopes) {
        try {
            const counts = await Promise.all(recordScopes.map((scope) => {
                const constraints = [];
                if (Number.isFinite(scope.startDate)) {
                    constraints.push(where("timestamp", ">=", scope.startDate));
                }
                if (Number.isFinite(scope.endDate)) {
                    constraints.push(where("timestamp", "<=", scope.endDate));
                }

                return getCountFromServer(query(collection(db, scope.collectionPath), ...constraints));
            }));

            setAllTimeRecordCount(counts.reduce((total, snapshot) => total + snapshot.data().count, 0));
        } catch (error) {
            console.error('Error counting all dangerous waste records:', error);
            setAllTimeRecordCount(null);
        }
    }

    // Every link in the machine -> company -> waste receiver chain can be missing in older
    // data, and each one fails the same way: no waste receiver, so no grouping columns.
    // The chain is traced here so a broken link can be told apart from a receiver that
    // simply has no grouping columns configured.
    async function resolveCompanyWasteReceiverId(companyId) {
        if (!companyId) {
            console.warn('Dangerous waste: this machine\'s location has no company, so no waste receiver can be resolved.');
            return null;
        }

        try {
            const companySnapshot = await getDoc(doc(db, 'companies', companyId));

            if (!companySnapshot.exists()) {
                console.warn(`Dangerous waste: company "${companyId}" has no document, so no waste receiver can be resolved.`);
                return null;
            }

            const companyWasteReceiverId = companySnapshot.data()?.waste_receiver;

            if (typeof companyWasteReceiverId !== 'string' || !companyWasteReceiverId.trim()) {
                console.warn(`Dangerous waste: company "${companyId}" has no waste_receiver field.`);
                return null;
            }

            return companyWasteReceiverId.trim();
        } catch (error) {
            console.error('Error resolving waste receiver for company:', error);
            return null;
        }
    }

    async function loadRecords() {
        setAllTimeRecordCount(null);

        if (isAppRecordsPage) {
            await loadAppRecords();
            return;
        }

        const locationSnapshot = await getDocs(
            query(
                collectionGroup(db, "locations"),
                where("id","==",locationId)
            )
        )

        if (locationSnapshot.empty) {
            console.log("locationSnapshot is empty")
            setPendingReviewCount(0)
        } else {
            const locationDoc = locationSnapshot.docs[0];
            const locationData = locationDoc.data()
            const locationCompanyId =
                locationData.company ||
                locationDoc.ref.parent?.parent?.id ||
                null;
            const display_unit = locationData.display_units[unitId]
            if (!display_unit) {
                setCurrentUnit(undefined)
                setLocalRecordsAndDerivedValues([])
                setMachineWasteReceiverId(null)
                setDeploymentDangerousWasteColumns(LEGACY_DANGEROUS_WASTE_COLUMNS)
                setPendingReviewCount(0)
                setTrendRecordSource(null)
                return
            }
            const displayUnitWithCompany = {
                ...display_unit,
                // The location owns the company relation, because locations are stored
                // beneath the company they belong to. A company on the display unit is
                // only a fallback, since it can be stale.
                company: locationCompanyId || display_unit.company,
            };
            setCurrentUnit(displayUnitWithCompany)
            setMachineWasteReceiverId(await resolveCompanyWasteReceiverId(displayUnitWithCompany.company))
            await loadDangerousWasteDisplayConfig(displayUnitWithCompany)
            const unitRanges = Array.isArray(displayUnitWithCompany.unit_ranges) ? displayUnitWithCompany.unit_ranges : []

            const recordScopes = buildMachineRecordScopes(unitRanges, { companyId: locationCompanyId })
            setTrendRecordSource({ scopes: recordScopes, deduplicateById: false })
            const allTimeRecordScopes = recordScopes.map(({ collectionPath, startDate, endDate }) => ({
                collectionPath,
                startDate,
                endDate,
            }))

            // Only the records inside the selected period are retrieved, so the period
            // bounds the data itself rather than merely filtering it after.
            var recordsNewValue = await fetchDangerousWasteRecords(recordScopes, {
                startUnix: isMarkedForReviewPane ? null : startUnix,
                endUnix: isMarkedForReviewPane ? null : end_unix,
            })

            if (isMarkedForReviewPane) {
                recordsNewValue = recordsNewValue.filter((record) => hasUnresolvedEvalRequests(record))
            }

            setLocalRecordsAndDerivedValues(recordsNewValue)
            if (isMarkedForReviewPane) {
                setAllTimeRecordCount(recordsNewValue.length)
                setPendingReviewCount(recordsNewValue.length)
            } else {
                loadAllTimeRecordCount(allTimeRecordScopes)

                // The review tab count must reflect all-time unresolved items even while
                // Dashboard/Billeder show period-scoped records.
                Promise.all(
                    allTimeRecordScopes.map((scope) => (
                        getDocs(query(
                            collection(db, scope.collectionPath),
                            where("timestamp", ">=", scope.startDate),
                            where("timestamp", "<=", scope.endDate),
                            orderBy("timestamp", "desc"),
                        ))
                    ))
                ).then((allSnapshots) => {
                    let unresolvedCount = 0
                    allSnapshots.forEach((snapshot) => {
                        snapshot.docs.forEach((_doc) => {
                            const record = _doc.data()
                            if (record?.is_test === true) return
                            if (hasUnresolvedEvalRequests(record)) {
                                unresolvedCount += 1
                            }
                        })
                    })

                    setPendingReviewCount(unresolvedCount)
                }).catch((error) => {
                    console.error('Error loading unresolved review count:', error)
                    setPendingReviewCount(0)
                })
            }
        }
    }

    function onDialogChangedRecord(newRecord) {
        console.log("onDialogChangedRecord")
        updateRecordInLocalRecords(newRecord)
    }

    function updateRecordInLocalRecords(_record) {
        var index = -1
        for (let i = 0; i < localRecords.length && index == -1; i++) {
            if(localRecords[i].record_id === _record.record_id) {
                index = i
            }
        }

        if (index != -1) {
            let localRecordsNewValue = localRecords.slice(0, index)
            if (!(isMarkedForReviewPane && !hasUnresolvedEvalRequests(_record))) {
                localRecordsNewValue.push(_record)
            }
            localRecordsNewValue = localRecordsNewValue.concat(localRecords.slice(index + 1))
            setLocalRecordsAndDerivedValues(localRecordsNewValue)
        }
    }

    function setLocalRecordsAndDerivedValues(newValue) {
            setLocalRecords(newValue)
            setRecords(newValue)
            setFlipAccountedRecords(newValue)
            if (isMarkedForReviewPane) {
            setPendingReviewCount(newValue.length)
            }
    }

    function nextPage() {
        setCurrentPage((page) => Math.min(page + 1, Math.max(totalPages() - 1, 0)))
    }

    function prevPage() {
        setCurrentPage((page) => Math.max(page - 1, 0))
    }

    function handlePaginatorClick(size) {
        setPageSize(size)
        setCurrentPage(0)
        setShowPagePaginatorDropdown(false)
    }

    function handlePaginatorDropdownClick() {
        setShowPagePaginatorDropdown((isOpen) => !isOpen)
    }

    const openImageDialog = (record, index) => {
    setModalInitialIndex(index);
    setIsDialogOpen(true);

    // // Refresh records in order to see the newest user evals.
    // if (currentUnit && currentUnit.unit_ranges && Array.isArray(currentUnit.unit_ranges) && currentUnit.unit_ranges.length > 0) {
    //     getRecordsForDisplayUnit(currentUnit, startUnix, end_unix, setRecordsIgnoringOwnEval);
    // } else {
    //     getRecords(unitId, startUnix, end_unix, setRecordsIgnoringOwnEval);
    // }
};


    const closeDialog = () => {
        //setCurrentRecordX(undefined);
        setIsDialogOpen(false);
    };

    const getCellClassName = (index, side) => {
        var className = "cdk-cell";

        const lastInPage = Math.min(pageSize, paneRecords.length - currentPage * pageSize);
        if (index === 0) {
            className += " first-row-" + side;
        } else if (index === lastInPage - 1) {
            className += " last-row-" + side;
        } else if (side === "right") {
            className += " right-cell"
        }
        
        return className;
    }

    const getVotedCategoryForRecords = (index) => {
        if (!votedCategoryForRecords[index] || votedCategoryForRecords[index] === "Ikke vurderet") {
            return ""
        }

        return votedCategoryForRecords[index]
    }

    const getFormattedDate = (timestamp) => {
        const formattedDate = new Intl.DateTimeFormat('da-DK', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
            }).format(new Date(timestamp));
            
            // Reformatting to "YYYY-MM-DD"
            const [day, month, year] = formattedDate.split('.');
            const formattedDateISO = `${year}-${month}-${day}`;

            return formattedDateISO;
    }

    const onUserEvalChange = (recordId, category) => {
        var localRecordsNewValue = [...localRecords];
        const index = localRecords.findIndex((elem) => elem.record_id === recordId);
        const userId = user.uid;

        if(!localRecordsNewValue[index].user_evals) {
            localRecordsNewValue[index].user_evals = {}
        }
        localRecordsNewValue[index].user_evals[userId] = category;
        setLocalRecords(localRecordsNewValue);
    }

    const onNewCategorySubmitted = (recordId, category) => {
        var localRecordsNewValue = [...localRecords];
        const index = localRecords.findIndex((elem) => elem.record_id === recordId);
        const userId = user.uid;
        if(!localRecordsNewValue[index].user_evals) {
            localRecordsNewValue[index].user_evals = {}
        }
        localRecordsNewValue[index].user_evals[userId] = category;
        setLocalRecords(localRecordsNewValue);
    }

    const adjustedIndex = (index) => {
        // Account for reversed order, and current page
        return flipSort ? paneRecords.length - 1 - index - currentPage * pageSize : index + currentPage * pageSize;   
    }

    const handleClick = (e) => {
        if (meatBallButtonRef.current && meatBallButtonRef.current.contains(e.target)) {
            setIsMeatBallExpanded(!isMeatBallExpanded);
        } else {
            setIsMeatBallExpanded(false);
        }
    }

    async function downloadAsZip(imageUrls, csvContent) {
        let csvWithoutHeaders = csvContent.slice(1)
        console.log("downloadAsZip called");
        const zip = new JSZip();
        const folder = zip.folder("bulk_images");
        
        console.log("Fetching image blobs...")
        const blobs = await fetchImagesAsBlobs(imageUrls, 10)
        console.log('Fetched blobs:', blobs);

        console.log("Adding blobs to prepared zip folder")
        for (let i = 0; i < blobs.length; i++) {
            console.log("Image #:", i)
            const blob = blobs[i];
            const bulkDownloadCSVDataElement = csvWithoutHeaders[i];
            const fileName = bulkDownloadCSVDataElement[0];
            folder.file(fileName, blob);
        }
        console.log("Added blobs to prepared zip folder")
    
        folder.file("bulk_download.csv", convertToCSV(csvContent));
    
        console.log("Generating zip file...")
        // Generate the ZIP file and download it
        zip.generateAsync({ type: "blob" }).then((content) => {
            console.log("Zip file generated")
            console.log("Downloading zip file...")
            saveAs(content, "images.zip");
            console.log("Downloaded zip file")
        });
        }

        async function fetchImagesAsBlobs(urls, batchSize = 10) {
        const fetchBlob = async (url) => {
            console.log("Fetching result for: ", url);
            const response = await fetch(url);
            console.log("Fetched result for url.");
            if (!response.ok) {
                throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
            }
            console.log("Converting to blob")
            const _blob = await response.blob();
            console.log("Converted to blob")

            return _blob
        };
    
        const results = [];

        console.log("Starting batch fetching")
        console.log("Batch size: ", batchSize)
        for (let i = 0; i < urls.length; i += batchSize) {
            console.log("Batch fetching iteration: ", i);
            const batch = urls.slice(i, i + batchSize);
            
            let blobs = [];

            for(let j = 0; j < batch.length; j++) {
                console.log("Batch fetching iteration inner: ", j);
                console.log("Batch fetching iteration inner url: ", batch[j]);
                const url = batch[j];
                const _blob = await fetchBlob(url)
                blobs.push(_blob);
            }
            
            console.log("Batch fetched")
            results.push(...blobs);
        }
    
        return results;
    }
    

    const bulkDownloadClicked = async () => {
        console.log("Bulk download clicked");
        try {
            // Get the download URLs
            var imageUrls = [];
            var bulkDownloadCSVDataElements = [];
            var csvContent = []

            var headers = ["file_name", "machine_eval"]

            var userCache = {}

            console.log("Starting image url fetching loop");
            for (var i = 0; i < localRecords.length; i++) {
                console.log("Starting image fetching loop iteration: ", i);
                const record = localRecords[i];

                const imgRefURL = `images/${record.img_name}`
                const imgRef = ref(storage, imgRefURL);
                try {
                    console.log("Getting download URL for: ", record.img_name);
                    const imageURL = await getDownloadURL(imgRef);
                    console.log("Got image URL: ", imageURL);
                    imageUrls.push(imageURL);
                    
                    let fileName = imageURL.split("/").pop().split("%2F").pop().split("?")[0];

                    var bulkDownloadCSVDataElement = {
                        file_name: fileName,
                        machine_eval: record.eval
                    }

                    if (record.user_evals) {
                        for (let key in record.user_evals) {
                            let user_eval = record.user_evals[key];
                            let userName;
                            if (key in userCache) {
                                userName = userCache[key];
                            } else {
                                console.log("Getting user name for: ", key);
                                let userResults = await getOtherUserInfo([key]);

                                if (userResults.length > 0) {
                                    let user = userResults[0];
                                    console.log("Got user: ", user);
                                    userName = user.name
                                    userCache[key] = userName;
                                }
                            }

                            if (userName) {
                                bulkDownloadCSVDataElement[userName] = user_eval;

                                // TODO: Guard against people with same usernames, or make sure they can't have that.
                                if (!headers.includes(userName)) {
                                    headers.push(userName);
                                }
                            }
                        }
                    }

                    bulkDownloadCSVDataElements.push(bulkDownloadCSVDataElement);

                    console.log("Image fetching done for record.")
                } catch (error) {
                    console.log("Error getting download URL");
                    console.log("Record: ", record);
                    console.log("imgRefURL: ", imgRefURL);
                    console.log("imgRef: ", imgRef);
                    console.log("Error: ", error);
                }
            }

            csvContent.push(headers)

            for (var i = 0; i < bulkDownloadCSVDataElements.length; i++) {
                var row = []
                for (var j = 0; j < headers.length; j++) {
                    var header = headers[j]
                    var value = bulkDownloadCSVDataElements[i][header] ?? ""
                    row.push(value)
                }
                csvContent.push(row)
            }
        
            // Download the images as a ZIP
            console.log("About to download images as zip");
            await downloadAsZip(imageUrls, csvContent);
        } catch (error) {
            console.error("Error downloading images: ", error);
        }
    }

    const downloadCSVOnly = async () => {
        console.log("CSV-only download clicked");
        try {
            var bulkDownloadCSVDataElements = [];
            var csvContent = []
            var headers = ["file_name", "machine_eval"]
            var userCache = {}

            console.log("Starting CSV data collection");
            for (var i = 0; i < localRecords.length; i++) {
                const record = localRecords[i];
                let fileName = record.img_name;

                var bulkDownloadCSVDataElement = {
                    file_name: fileName,
                    machine_eval: record.eval
                }

                if (record.user_evals) {
                    for (let key in record.user_evals) {
                        let user_eval = record.user_evals[key];
                        let userName;
                        if (key in userCache) {
                            userName = userCache[key];
                        } else {
                            console.log("Getting user name for: ", key);
                            let userResults = await getOtherUserInfo([key]);

                            if (userResults.length > 0) {
                                let user = userResults[0];
                                console.log("Got user: ", user);
                                userName = user.name
                                userCache[key] = userName;
                            }
                        }

                        if (userName) {
                            bulkDownloadCSVDataElement[userName] = user_eval;

                            if (!headers.includes(userName)) {
                                headers.push(userName);
                            }
                        }
                    }
                }

                bulkDownloadCSVDataElements.push(bulkDownloadCSVDataElement);
            }

            csvContent.push(headers)

            for (var i = 0; i < bulkDownloadCSVDataElements.length; i++) {
                var row = []
                for (var j = 0; j < headers.length; j++) {
                    var header = headers[j]
                    var value = bulkDownloadCSVDataElements[i][header] ?? ""
                    row.push(value)
                }
                csvContent.push(row)
            }

            // Create and download the CSV file
            const csvString = convertToCSV(csvContent);
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, "records.csv");
        } catch (error) {
            console.error("Error downloading CSV: ", error);
        }
    }

    function getUserLocale() {
        var userLocale = 'da-DK'
        
        if (userData && userData.language) {
            userLocale = getDateLocaleFromLanguage(userData.language)
        }

        return userLocale
    }

    const convertToCSV = (objArray) => {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
    
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in array[i]) {
            if (line !== '') line += ',';
    
            line += array[i][index];
            }
            str += line + '\r\n';
        }
        return str;
        };

    const isCustomCategoryAlreadyIncluded = (category) => {
        var output = false;
        const classNames = currentUnit?.deployment_config?.classification?.class_names || [];
        if (currentUnit && classNames.length > 0) {
            for (let i = 0; i < classNames.length && !output; i++) {
                const translatedEval = t(classNames[i]);
                if (translatedEval === category) {
                    output = true;
                }
            }
        }

        return output;
    }

    const handleRecordSelect = (recordId, event) => {
            console.log("handleRecordSelect, shiftKey: ", event?.nativeEvent?.shiftKey, "lastSelectedRecord: ", lastSelectedRecord);
            if (event?.nativeEvent?.shiftKey && lastSelectedRecord) {
                // Get the current page records
                const currentPageRecords = flipAccountedRecords
                    .slice(currentPage * pageSize, (currentPage + 1) * pageSize);
                
                // Find indices in the current page
                const lastIndex = currentPageRecords.findIndex(record => record.record_id === lastSelectedRecord);
                const currentIndex = currentPageRecords.findIndex(record => record.record_id === recordId);
                
                if (lastIndex !== -1 && currentIndex !== -1) {
                    // Get the range of records to select
                    const start = Math.min(lastIndex, currentIndex);
                    const end = Math.max(lastIndex, currentIndex);
                    
                    const recordsToSelect = currentPageRecords
                        .slice(start, end + 1)
                        .map(record => record.record_id);
    
                    setSelectedRecords(prev => {
                        const newSelection = new Set([...prev]);
                        recordsToSelect.forEach(id => newSelection.add(id));
                        return Array.from(newSelection);
                    });
                }
            } else {
                const wasSelected = selectedRecords.includes(recordId);
                setSelectedRecords(prev => {
                    if (wasSelected) {
                        return prev.filter(id => id !== recordId);
                    } else {
                        return [...prev, recordId];
                    }
                });
                if (!wasSelected) {
                    setLastSelectedRecord(recordId);
                }
            }
        };
    
    const markSelectedRecordsAsTest = async (isTest) => {
        try {
            const isDisplayUnit = currentUnit && currentUnit.unit_ranges && Array.isArray(currentUnit.unit_ranges) && currentUnit.unit_ranges.length > 0;
            const updates = [];
            const updatedRecordPaths = new Set();
            const skippedRecordIds = new Set();

            const resolveRecordUnitId = (record) => {
                if (!isDisplayUnit) {
                    return unitId;
                }

                if (record.unit_id) {
                    return record.unit_id;
                }

                const rawTimestamp = record.timestamp instanceof Date ? record.timestamp.getTime() : Number(record.timestamp);
                if (!Number.isFinite(rawTimestamp)) {
                    return null;
                }

                const matchingRanges = currentUnit.unit_ranges.filter((range) => {
                    if (!range || !range.unit_id || range.start_date === undefined || range.start_date === null) {
                        return false;
                    }

                    const start = Number(range.start_date);
                    if (!Number.isFinite(start) || rawTimestamp < start) {
                        return false;
                    }

                    if (range.current === true) {
                        return true;
                    }

                    const end = Number(range.end_date);
                    return Number.isFinite(end) && rawTimestamp <= end;
                });

                if (matchingRanges.length === 0) {
                    return null;
                }

                // Prefer the most recent matching range.
                matchingRanges.sort((a, b) => Number(b.start_date) - Number(a.start_date));
                return matchingRanges[0].unit_id;
            };

            selectedRecords.forEach((recordId) => {
                const matchingRecords = localRecords.filter((record) => record.record_id === recordId);
                matchingRecords.forEach((record) => {
                    const recordUnitId = resolveRecordUnitId(record);
                    if (!recordUnitId) {
                        skippedRecordIds.add(recordId);
                        return;
                    }

                    const pathKey = `${recordUnitId}/${recordId}`;
                    if (updatedRecordPaths.has(pathKey)) {
                        return;
                    }

                    updatedRecordPaths.add(pathKey);
                    const recordRef = record.record_path
                        ? doc(db, record.record_path)
                        : doc(db, 'units', recordUnitId, 'dangerous-waste-records', recordId);
                    updates.push(updateDoc(recordRef, { is_test: isTest }));
                });
            });

            await Promise.all(updates);
            
            // // Refresh records to show updated state
            // if (isDisplayUnit) {
            //     getRecordsForDisplayUnit(currentUnit, startUnix, end_unix, setRecordsIgnoringOwnEval);
            // } else {
            //     getRecords(unitId, startUnix, end_unix, setRecordsIgnoringOwnEval);
            // }
            setSelectedRecords([]); // Clear selection after update

            if (skippedRecordIds.size > 0) {
                const skippedList = Array.from(skippedRecordIds);
                console.warn(
                    "Skipped marking test for records with no matching display-unit range:",
                    skippedList
                );
                window.alert(
                    `Marked ${updatedRecordPaths.size} selected records as test. ` +
                    `${skippedList.length} were skipped because no matching display-unit range was found.`
                );
            }
        } catch (error) {
            console.error("Error updating records:", error);
        }
    };

    const handleDatePicked = async (start_unix, end_unix, time_unit) => {
        // The picker clamps an ongoing period to "now", which would make the very same
        // period look new every time the picker remounts. The period is derived from its
        // start and unit instead, which is equivalent because no record lies in the future.
        setStartUnix(start_unix);
        setEndUnix(getPeriodEndUnix(start_unix, time_unit));
        setSelectedTimeUnit(time_unit);
        setCurrentPage(0);
        setLastSelectedRecord(null);
        setSelectedRecords([]);
    };

    const handleSortChange = () => {
        setFlipSort(flipSort === false);
        setCurrentPage(0);
        setLastSelectedRecord(null);
        setSelectedRecords([]);
        filterRecords();
    };

    const setRecordsIgnoringOwnEval = (records) => {
        // Don't overwrite own evals
        var recordsNewValue = [...records];
        recordsNewValue = recordsNewValue.map((elem) => {
            var newRecord = {...elem};
            if (!newRecord.user_evals) {
                newRecord["user_evals"] = {};
            }
            if (!newRecord.admin_evals) {
                newRecord["admin_evals"] = {};
            }

            if (localRecords) {
                const record = localRecords.find((record) => record.record_id === elem.record_id);

                if (record) {
                    if (record.user_evals) {
                        newRecord["user_evals"][user.uid] = record["user_evals"][user.uid];
                    }
                    if (record.admin_evals) {
                        newRecord["admin_evals"][user.uid] = record["admin_evals"][user.uid];
                    }
                }
            }

            return newRecord;
        })
        setRecords(recordsNewValue);
    }

    const doesRecordContainEvals = (record) => {
        return record.user_evals || (record.admin_evals && userData && userData.isAdmin)
    }

    const getVotingForItem = (record) => {
        if(doesRecordContainEvals(record)) {
            var users_voted = []
            var admin_users_voted = []
            if (record.user_eval) {
                users_voted = Object.keys(record.user_evals)
            }
            if (userData && userData.isAdmin && record.admin_evals) {
                admin_users_voted = Object.keys(record.admin_evals)
            }
            let votesForCategory = {}
            var highestVoted;
            var tie = false
            for (let i = 0; i < (users_voted.length + admin_users_voted.length); i++) {
                const category = i < users_voted.length ? record.user_evals[users_voted[i]] : record.admin_evals[admin_users_voted[i - users_voted.length]]
                
                if (category) {
                    const translatedCategory = t(category)
                    if (votesForCategory[translatedCategory]) {
                        votesForCategory[translatedCategory] += 1
                    } else {
                        votesForCategory[translatedCategory] = 1
                    }

                    if(!highestVoted) {
                        highestVoted = translatedCategory
                    } else if (highestVoted != translatedCategory) {
                        const votes = votesForCategory[translatedCategory]

                        if (votes > 0) {
                            /*
                            NOTE: this line was buggy for some reason. 
                            votesForCategory[highestVoted] does not have the correct value
                            and it is not even corresponding to the value printed for the dict.
                            const highestVotes = votesForCategory[highestVoted]
                            */

                            var highestVotes = 0
                            var highestVotedOption = undefined
                            const classNames = currentUnit.deployment_config?.classification?.class_names || [];
                            const categoryOptions = localCustomEvalCategories.concat(classNames)
                            for (let categoryKey in categoryOptions) {
                                let candidateVotes = 0
                                const categoryOption = categoryOptions[categoryKey]
                                const translatedCategoryOption = t(categoryOption)

                                for (let userEvalKey in record.user_evals) {
                                    let _userEval = record.user_evals[userEvalKey]
                                    let _translatedUserEval = t(_userEval)
                                    if (_translatedUserEval == translatedCategoryOption) {
                                        candidateVotes += 1
                                    }
                                }

                                if (candidateVotes > highestVotes) {
                                    highestVotes = candidateVotes
                                    highestVotedOption = categoryOption
                                    highestVoted = highestVotedOption
                                    tie = false
                                } else if (candidateVotes === highestVotes) {
                                    tie = true
                                }
                            }
                        }
                    }
                }
            }

            if (tie) {
                return "Uafgjort"
            }
            
            if (highestVoted) {
                return highestVoted
            }

        }

        return "Ikke vurderet"
    }

    const filterRecords = () => {
        var data = records.filter((elem) => {
            var output = true;
            if (activeFilter !== "") {
                const voting = getVotingForItem(elem)
                var votingOrEval = voting
                if (voting === "Ikke vurderet") {
                    votingOrEval = elem.eval
                }

                const votingEquals = votingOrEval === activeFilter
                const votingEqualsTranslated = votingOrEval === t(activeFilter)

                if (!votingEquals && !votingEqualsTranslated) {
                    output = false;
                }
            }

            return output;
        });

        setLocalRecords(data);
    }

    const getMergedUserEvals = (record) => {
        const merged = {};
        if (record?.user_evals && typeof record.user_evals === 'object') {
            Object.assign(merged, record.user_evals);
        }
        if (record?.admin_evals && typeof record.admin_evals === 'object') {
            Object.assign(merged, record.admin_evals);
        }

        Object.keys(merged).forEach((userId) => {
            const value = merged[userId];
            if (value == null || String(value).trim() === '') {
                delete merged[userId];
            }
        });

        return merged;
    };

    const getMergedVoteVerdicts = (record) => {
        const merged = {};
        if (record?.user_vote_verdicts && typeof record.user_vote_verdicts === 'object') {
            Object.assign(merged, record.user_vote_verdicts);
        }
        if (record?.admin_vote_verdicts && typeof record.admin_vote_verdicts === 'object') {
            Object.assign(merged, record.admin_vote_verdicts);
        }

        Object.keys(merged).forEach((userId) => {
            const value = String(merged[userId] || '').trim().toLowerCase();
            if (value !== 'correct' && value !== 'incorrect') {
                delete merged[userId];
            } else {
                merged[userId] = value;
            }
        });

        return merged;
    };

    const getMachineConstituent = (record) => getDangerousWasteRecordValue(record, 'constituent');

    const getUserEvalConstituent = (evalValue) => {
        if (evalValue == null) return '';

        if (typeof evalValue === 'object') {
            return String(evalValue.constituent || evalValue.category || '').trim();
        }

        const text = String(evalValue).trim();
        if (!text) return '';

        // Sorting-list vote values are stored like "Constituent | Category | Instruction".
        if (text.includes('|')) {
            return text.split('|')[0].trim();
        }

        return text;
    };

    const getUserResolvedVerdict = (record, userId, userEvals, voteVerdicts) => {
        if (voteVerdicts[userId] === 'correct' || voteVerdicts[userId] === 'incorrect') {
            return voteVerdicts[userId];
        }

        const machineConstituent = String(getMachineConstituent(record) || '').trim();
        if (!machineConstituent) return null;

        const evalConstituent = getUserEvalConstituent(userEvals[userId]);
        if (!evalConstituent) return null;

        return evalConstituent === machineConstituent ? 'correct' : 'incorrect';
    };

    const getRecordResolvedVoteVerdict = (record) => {
        const userEvals = getMergedUserEvals(record);
        const evaluatedUserIds = Object.keys(userEvals);
        if (evaluatedUserIds.length === 0) return null;
        const voteVerdicts = getMergedVoteVerdicts(record);

        const prioritizedEvaluators = prioritizedUserIds.filter((userId) =>
            Object.prototype.hasOwnProperty.call(userEvals, userId),
        );

        if (prioritizedEvaluators.length > 0) {
            return getUserResolvedVerdict(record, prioritizedEvaluators[0], userEvals, voteVerdicts);
        }

        const alphabeticFallbackUserIds = [...evaluatedUserIds].sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: 'base' }),
        );
        return getUserResolvedVerdict(record, alphabeticFallbackUserIds[0], userEvals, voteVerdicts);
    };

    const getRecordCommentCount = (record) => {
        if (!record?.user_comments || typeof record.user_comments !== 'object') return 0;
        return Object.values(record.user_comments).filter((comment) => {
            return comment != null && String(comment).trim() !== '';
        }).length;
    };

    function formatTableColumnValue(record, columnId) {
        const value = getDangerousWasteRecordTableValue(
            record,
            columnId,
            tableColumnIndexById.get(columnId),
            allDangerousWasteColumns.length,
        );
        if (!value) return '';
        return value.length <= TABLE_CELL_PREVIEW_MAX
            ? value
            : `${value.slice(0, TABLE_CELL_PREVIEW_MAX)}...`;
    }

    function getTableColumnStyle(record, columnId) {
        if (columnId !== 'category') return {};
        const value = getDangerousWasteRecordTableValue(
            record,
            columnId,
            tableColumnIndexById.get(columnId),
            allDangerousWasteColumns.length,
        );
        return value ? { color: getColorForCategory(value) } : {};
    }

    useEffect(()=> {
        if (!isMarkedForReviewPane && (startUnix === null || end_unix === null)) return
        loadRecords()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAppRecordsPage, appOwnerType, appOwnerId, locationId, unitId, startUnix, end_unix, isMarkedForReviewPane])

    // Evaluerede Billeder membership is any merged vote; the verdict filter then
    // narrows to Korrekt/Forkert/Uafklaret using the same resolved-verdict logic
    // as the record table's status column.
    const paneRecords = isEvaluatedImagesPane
        ? flipAccountedRecords.filter((record) => {
            if (Object.keys(getMergedUserEvals(record)).length === 0) return false;
            if (evaluatedVerdictFilter === 'all') return true;
            const verdict = getRecordResolvedVoteVerdict(record);
            if (evaluatedVerdictFilter === 'unresolved') return verdict === null;
            return verdict === evaluatedVerdictFilter;
        })
        : flipAccountedRecords;

    useEffect(() => {
        setCurrentPage(0);
    }, [currentPane, evaluatedVerdictFilter]);

    const pagedRecords = paneRecords.slice(currentPage * pageSize, (currentPage + 1) * pageSize);

    return <div className="DangerousWastePage">
        <div className="sub-sub-header">
            <div className="toggle">
                <div className={isDashboardPane ? 'toggle-active' : 'toggle-inactive'}>
                    <div className="inner-toggle" onClick={() => navigate(`${paneBasePath}/${DANGEROUS_WASTE_PANES.dashboard}`)}>
                        <div className={`toggle-text ${isDashboardPane ? 'toggle-white' : ''}`}>
                            {t("Dashboard")}
                        </div>
                    </div>
                </div>
                <div className={currentPane === DANGEROUS_WASTE_PANES.images ? 'toggle-active' : 'toggle-inactive'}>
                    <div className="inner-toggle" onClick={() => navigate(`${paneBasePath}/${DANGEROUS_WASTE_PANES.images}`)}>
                        <div className={`toggle-text ${currentPane === DANGEROUS_WASTE_PANES.images ? 'toggle-white' : ''}`}>
                            {t("Billeder")}
                        </div>
                    </div>
                </div>
                <div className={isMarkedForReviewPane ? 'toggle-active' : 'toggle-inactive'}>
                    <div className="inner-toggle" onClick={() => navigate(`${paneBasePath}/${DANGEROUS_WASTE_PANES.markedForReview}`)}>
                        <div className={`toggle-text ${isMarkedForReviewPane ? 'toggle-white' : ''}`}>
                            {t("Ubesvarede anmodninger")} ({pendingReviewCount})
                        </div>
                    </div>
                </div>
                <div className={isEvaluatedImagesPane ? 'toggle-active' : 'toggle-inactive'}>
                    <div className="inner-toggle" onClick={() => navigate(`${paneBasePath}/${DANGEROUS_WASTE_PANES.evaluatedImages}`)}>
                        <div className={`toggle-text ${isEvaluatedImagesPane ? 'toggle-white' : ''}`}>
                            {t("Evaluerede billeder")}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {isDashboardPane ? (
            <DangerousWasteDashboardPane
                activationCount={localRecords.length}
                hasGroupingColumns={groupingColumns.length > 0}
                recordGroups={recordGroups}
                activationTrend={activationTrend}
                isTrendLoading={isTrendLoading}
                trendWindowDays={trendWindowDays}
                onTrendWindowDaysChange={setTrendWindowDays}
                datePicker={(
                    <DatePickerComponent
                        horizontalAnchor="right"
                        defaultTime={startUnix ? new Date(startUnix) : new Date()}
                        defaultUnit={selectedTimeUnit}
                        onDateSelected={handleDatePicked}
                    />
                )}
            />
        ) : (
        <div className="ImagesSubPage">
        <div className="outer-wrapper">
            <div className="main-wrapper">
                {isEvaluatedImagesPane && (
                    <div className="evaluated-verdict-filter">
                        {EVALUATED_VERDICT_FILTERS.map((filter) => (
                            <button
                                key={filter.value}
                                type="button"
                                className={`evaluated-verdict-filter-btn ${evaluatedVerdictFilter === filter.value ? 'evaluated-verdict-filter-btn-active' : ''}`}
                                onClick={() => setEvaluatedVerdictFilter(filter.value)}
                            >
                                {t(filter.label)}
                            </button>
                        ))}
                    </div>
                )}
                {/* <div className="records-tabs">
                    <div className="category-buttons">
                        <button 
                            className="aris-button-secondary" 
                            // onClick={() => setActiveFilter('')}
                            style={{
                                color: activeFilter === "" ? "var(--gray-900)" : "#fff",
                                backgroundColor: activeFilter === "" ? "var(--primary-green-500)" : ''
                            }}
                        >
                            {t("Alle")}
                        </button>
                        {currentUnit?.deployment_config?.classification?.class_names?.map((category, i) => (
                            <button
                                key={category}
                                className="aris-button-secondary"
                                onClick={(e) => setActiveFilter(category)}
                                style={{
                                    color: activeFilter === category ? "var(--gray-900)" : "#fff",
                                    backgroundColor: activeFilter === category ? getColorForCategory(activeFilter) : ''
                                }}
                            >
                                {t(category)}
                            </button>
                        ))}

                        {localCustomEvalCategories.map((category, i) => (
                            <button
                                key={category}
                                className="aris-button-secondary"
                                onClick={(e) => setActiveFilter(category)}
                                style={{
                                    color: activeFilter === category ? "var(--gray-900)" : "#fff",
                                    backgroundColor: activeFilter === category ? getColorForCategory(activeFilter) : ''
                                }}
                            >
                                {t(category)}
                            </button>
                        ))}
                    </div>

                    <button className="sort-button" onClick={handleSortChange}>
                        <span>{flipSort ? t("Ældste først") : t("Nyeste først")}</span>
                        <div className="date-picker-toggle-arrow sort-arrow">
                            <img
                                src={down_arrow}
                                alt="Sort Arrow"
                                style={{ transform: flipSort ? 'rotate(180deg)' : '' }}
                            />
                        </div>
                    </button>
                    <DatePickerComponent
                        onDateSelected={handleDatePicked}
                    />
                </div> */}
                <div className="records-table-wrapper">
                    <div className="records-table">
                        <table>
                            <thead>
                                <tr className="card-header">
                                    {/* {userData.isAdmin && <th style={{ width: '40px' }}></th>} */}
                                    <th style={{ paddingLeft: '4px' }}>{t("Dato")}</th>
                                    <th>{t("Dag")}</th>
                                    <th>{t("Tid")}</th>
                                    {isAppRecordsPage && <th>{t("Bruger")}</th>}
                                    {dangerousWasteColumns.map((column) => (
                                        <th key={column.id}>{t(column.display_name)}</th>
                                    ))}
                                    <th>{t("Vurdering")}</th>
                                    <th>
                                        {/* { userData.isAdmin &&
                                            <div className="meat-balls-wrapper">
                                                <div 
                                                    className="meat-balls-button-wrapper"
                                                    ref={meatBallButtonRef}
                                                >
                                                    <div className="meat-balls-button">
                                                        <img src={meat_balls} alt="Options button" />
                                                    </div>
                                                    <div className="meat-balls-menu-anchor">
                                                        {isMeatBallExpanded && (
                                                            <div className="meat-balls-menu">
                                                                <div 
                                                                    className="bulk-download-button"
                                                                    onClick={bulkDownloadClicked}
                                                                >
                                                                    Download all images
                                                                </div>
                                                                <div 
                                                                    className="bulk-download-button"
                                                                    onClick={downloadCSVOnly}
                                                                >
                                                                    Download CSV only
                                                                </div>
                                                                {selectedRecords.length > 0 && (
                                                                    <>
                                                                        <div 
                                                                            className="bulk-download-button"
                                                                            onClick={() => markSelectedRecordsAsTest(true)}
                                                                        >
                                                                            Mark selected as test
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div> }*/
                                        }
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {pagedRecords
                                    .map((element, index) => {
                                        const commentCount = getRecordCommentCount(element);
                                        const resolvedVoteVerdict = getRecordResolvedVoteVerdict(element);
                                        const unresolvedRequest = hasUnresolvedEvalRequests(element);
                                        const actorBadge = isAppRecordsPage ? getAppRecordActorBadge(element) : null;

                                        return (
                                        <tr
                                            key={element.record_id ?? element.timestamp}
                                            className={unresolvedRequest ? 'row-unresolved-request' : ''}
                                        >
                                            {/* {userData.isAdmin && (
                                                <td className="cdk-cell">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={selectedRecords.includes(element.record_id)}
                                                        onChange={(event) => handleRecordSelect(element.record_id, event)}
                                                    />
                                                </td>
                                            )} */}
                                            <td className={getCellClassName(index, "left")}>
                                                {getFormattedDate(element.timestamp)}
                                            </td>
                                            <td className="cdk-cell" style={{ textTransform: 'capitalize' }}>
                                                {new Intl.DateTimeFormat(getUserLocale(), { weekday: 'short' }).format(new Date(element.timestamp))}
                                            </td>
                                            <td 
                                                className="cdk-cell"
                                            >
                                                { new Date(element.timestamp)
                                                    .toLocaleTimeString(
                                                        getUserLocale()
                                                    )
                                                    .replace(/\./g, ':')
                                                }
                                            </td>
                                            {isAppRecordsPage && (
                                                <td className="cdk-cell">
                                                    {actorBadge && (
                                                        <div
                                                            className="record-actor-badge"
                                                            title={actorBadge.tooltip}
                                                            style={{ backgroundColor: actorBadge.color }}
                                                        >
                                                            {actorBadge.text}
                                                        </div>
                                                    )}
                                                </td>
                                            )}
                                            {dangerousWasteColumns.map((column) => {
                                                const value = formatTableColumnValue(element, column.id);
                                                return (
                                                    <td
                                                        key={column.id}
                                                        className="cdk-cell"
                                                        style={getTableColumnStyle(element, column.id)}
                                                    >
                                                        {value ? t(value) : ''}
                                                    </td>
                                                );
                                            })}
                                            <td className="cdk-cell">
                                                <span className="record-vote-status-wrap">
                                                    {resolvedVoteVerdict === 'correct' && (
                                                        <CheckCircleIcon className="record-vote-icon record-vote-icon-correct" fontSize="small" />
                                                    )}
                                                    {resolvedVoteVerdict === 'incorrect' && (
                                                        <CancelIcon className="record-vote-icon record-vote-icon-incorrect" fontSize="small" />
                                                    )}
                                                    {commentCount > 0 ? (
                                                        <span className="record-comments-indicator">
                                                            <CommentOutlinedIcon fontSize="small" />
                                                            <span>{commentCount}</span>
                                                        </span>
                                                    ) : ''}
                                                </span>
                                            </td>
                                            <td className={getCellClassName(index, "right")}>
                                                <button
                                                    className="aris-button-primary"
                                                    style={{ fontSize: '14px', lineHeight: '14px', padding: '9px 12px' }}
                                                    onClick={(e) => openImageDialog(element, adjustedIndex(index))}
                                                >
                                                    {t("Se billede")}
                                                </button>
                                            </td>
                                        </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                        <div className="table-footer">
                            {paneRecords.length > 0 && (
                                <div className="page-paginator-dropdown-wrapper" onClick={handlePaginatorDropdownClick}>
                                    <div className="page-paginator-text">{t("Pr. side")}: {pageSize}</div>
                                    <div className="page-paginator-dropdown-toggle">
                                        <img
                                            className={`tiny-icon ${showPagePaginatorDropdown ? 'page-paginator-dropdown-toggle-on' : ''}`}
                                            src={down_arrow}
                                            alt="."
                                        />
                                    </div>
                                    {showPagePaginatorDropdown && (
                                        <div className="page-paginator-dropdown">
                                            {[10, 20, 50, 100].map((size) => (
                                                <div key={size} className="page-paginator-dropdown-elem" onClick={() => handlePaginatorClick(size)}>
                                                    {size}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="page-paginator-navigator">
                                <div
                                    className={`page-paginator-navigator-elem ${currentPage === 0 ? 'page-paginator-navigator-elem-disabled' : ''}`}
                                    onClick={prevPage}
                                >
                                    <img className="page-paginator-left-arrow" src={down_arrow} alt="." />
                                </div>
                                <div className="page-paginator-navigator-current">
                                    {paneRecords.length === 0 ? 0 : currentPage * pageSize + 1} -{' '}
                                    {Math.min((currentPage + 1) * pageSize, paneRecords.length)} {t("af")} {paneRecords.length}
                                </div>
                                <div
                                    className={`page-paginator-navigator-elem ${currentPage >= totalPages() - 1 ? 'page-paginator-navigator-elem-disabled' : ''}`}
                                    onClick={nextPage}
                                >
                                    <img className="page-paginator-right-arrow" src={down_arrow} alt="." />
                                </div>
                            </div>
                            {isMarkedForReviewPane && (
                                <div className="page-paginator-all-time-text">
                                    {t("Ubesvarede anmodninger")}: {localRecords.length}
                                </div>
                            )}
                            {!isMarkedForReviewPane && allTimeRecordCount !== null && allTimeRecordCount > localRecords.length && (
                                <div className="page-paginator-all-time-text">
                                    {allTimeRecordCount} {t("registreringer i alt")}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        )}
        <DialogRecordProvider 
            // onIndexChange={handleIndexChange}
        >
            <Modal
                open={isDialogOpen}
                onClose={closeDialog}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition={false}
            >
                <>
                    <DangerousWasteRecordDialog
                        isOpen={isDialogOpen}
                        initialIndex={modalInitialIndex}
                        localRecords={paneRecords}
                        onDialogChangedRecord={onDialogChangedRecord}
                        onClose={closeDialog}
                        dangerousWasteColumns={dangerousWasteColumns}
                        sortingListColumns={allDangerousWasteColumns}
                        wasteReceiver={wasteReceiver}
                    />
                </>
            </Modal>
        </DialogRecordProvider>
      </div>
}

export default DangerousWasteImagesPage
